import { Container, useMediaQuery } from "@mui/material";
import { Breakpoint, useTheme } from "@mui/material/styles";
import React from "react";

interface PageLayoutControllerProps {
  children: JSX.Element | React.ReactNode;
  mobileLayout: string[][];
  desktopLayout: string[][];
  spacing?: number;
  maxWidth?: Breakpoint;
  height?: string;
  container?: boolean;
}
const PageLayoutController = (props: PageLayoutControllerProps) => {
  const { children, mobileLayout, desktopLayout, spacing, maxWidth, height, container } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  // return string version of the layout matrix, needed for css grid
  const wrapArea = (area: string): string => `"${area}"`;
  const mapThroughLayout = React.useCallback((layout: string[][]) => {
    let rows: string = "";
    for (const area of layout) {
      const formattedArea = area.join(" ");
      rows = `${rows} ${wrapArea(formattedArea)}`;
    }
    return rows;
  }, []);

  const moblieLength = mobileLayout.length > 0 ? mobileLayout[0].length : 1;
  const desktopLength = desktopLayout.length > 0 ? desktopLayout[0].length : 1;

  if (container) {
    return (
      <Container maxWidth={maxWidth}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: `repeat(${isMobile ? moblieLength : desktopLength}, 1fr)`,
            gap: spacing || 2,
            gridTemplateAreas: `${mapThroughLayout(isMobile ? mobileLayout : desktopLayout)}`,
            height: height,
          }}>
          {children}
        </div>
      </Container>
    );
  } else {
    return (
      <div
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(${isMobile ? moblieLength : desktopLength}, 1fr)`,
          gap: spacing || 2,
          gridTemplateAreas: `${mapThroughLayout(isMobile ? mobileLayout : desktopLayout)}`,
          height: height,
        }}>
        {children}
      </div>
    );
  }
};

export default PageLayoutController;
